import { Fragment, useEffect, useRef, useState } from 'react'
import HttpService from '../services/HttpService'
import { Button, Card, EmptyState, Field, KebabMenu, Modal, Page, inputClass } from './ui'

export default function Webhooks(props) {
    const [open, setOpen] = useState(false)
    const [id, setId] = useState('')
    const [nombreWebhook, setNombreWebhook] = useState('')
    const [urlWebhook, setUrlWebhook] = useState('')
    const [webhooks, setWebhooks] = useState([])
    const [modalTitle, setModalTitle] = useState()
    const [validateNombreWebhookError, setValidateNombreWebhookError] = useState()
    const [validateUrlWebhookError, setValidateUrlWebhookError] = useState()
    const validForm = useRef(true)
    const creating = useRef(true)

    useEffect(() => {
        props.handleTitulo('Webhooks')
        getWebhooks()
    }, [])

    const getWebhooks = () => {
        HttpService.getAxiosClient().get('/webhooks').then((res) => setWebhooks(res.data))
    }

    const guardarWebhook = () => {
        validateForm()
        if (validForm.current) {
            if (creating.current) {
                HttpService.getAxiosClient()
                    .post('/webhooks', { nombreWebhook, url: urlWebhook })
                    .then(() => {
                        getWebhooks()
                        setOpen(false)
                    })
            } else {
                HttpService.getAxiosClient()
                    .post(`/webhooks/${id}`, { nombreWebhook, url: urlWebhook })
                    .then(() => {
                        getWebhooks()
                        setOpen(false)
                    })
            }
        }
    }

    const validateForm = () => {
        validForm.current = true
        if (!nombreWebhook?.trim()) {
            setValidateNombreWebhookError('Debe ingresar el nombre del webhook')
            validForm.current = false
        } else {
            setValidateNombreWebhookError(null)
        }
        if (!urlWebhook?.trim()) {
            setValidateUrlWebhookError('Debe ingresar la url del webhook')
            validForm.current = false
        } else {
            setValidateUrlWebhookError(null)
        }
    }

    const editar = (webhook) => {
        creating.current = false
        setId(webhook.idWebhook)
        setNombreWebhook(webhook.nombreWebhook)
        setUrlWebhook(webhook.url)
        setModalTitle('Editar webhook')
        setOpen(true)
    }

    return (
        <Page
            description="Notificaciones de cambio de estado de tus operaciones CoDi."
            actions={
                <Button
                    onClick={() => {
                        creating.current = true
                        setOpen(true)
                        setModalTitle('Agregar webhook')
                        setNombreWebhook('')
                        setUrlWebhook('')
                    }}
                >
                    Nuevo webhook
                </Button>
            }
        >
            {webhooks.length === 0 ? (
                <EmptyState title="Sin webhooks" description="Agrega un endpoint para recibir eventos." />
            ) : (
                <ul className="grid gap-4 lg:grid-cols-2">
                    {webhooks.map((webhook) => (
                        <li key={webhook.idWebhook}>
                            <Card>
                                <div className="flex items-start justify-between border-b border-slate-100 px-5 py-4">
                                    <p className="text-sm font-semibold uppercase text-slate-900">{webhook.nombreWebhook}</p>
                                    <KebabMenu
                                        items={[
                                            { label: 'Editar', onClick: () => editar(webhook) },
                                            { label: 'Eliminar', onClick: () => {}, danger: true },
                                        ]}
                                    />
                                </div>
                                <div className="space-y-2 px-5 py-4 text-sm">
                                    <p><span className="text-slate-500">ID</span> <span className="ml-2 font-mono text-xs text-slate-700">{webhook.idWebhook}</span></p>
                                    <p className="break-all"><span className="text-slate-500">URL</span> <span className="ml-2 text-slate-700">{webhook.url}</span></p>
                                </div>
                            </Card>
                        </li>
                    ))}
                </ul>
            )}

            <Modal
                open={open}
                onClose={setOpen}
                title={modalTitle}
                footer={
                    <Fragment>
                        <Button variant="secondary" onClick={() => setOpen(false)}>Cancelar</Button>
                        <Button onClick={guardarWebhook}>Guardar</Button>
                    </Fragment>
                }
            >
                <Field label="Nombre del webhook" error={validateNombreWebhookError}>
                    <input type="text" value={nombreWebhook} onChange={(e) => setNombreWebhook(e.target.value)} className={inputClass} />
                </Field>
                <Field label="URL" error={validateUrlWebhookError}>
                    <input type="text" value={urlWebhook} onChange={(e) => setUrlWebhook(e.target.value)} className={inputClass} />
                </Field>
            </Modal>
        </Page>
    )
}
